module.exports = __webpack_public_path__ + "static/img/pic_cpraedzm@2x.2005197d.png";